import { lobby, match, screen, toast } from '../store';
import { Campaign } from './Campaign';
import { HelpModal } from './common';
import { Lobby } from './Lobby';
import { Locker } from './Locker';
import { MapGallery } from './MapGallery';
import { Match } from './Match';
import { Results } from './Results';
import { TopBar } from './TopBar';

export function App() {
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('gallery')) return <MapGallery />;
  const s = screen.value;
  const m = match.value;
  return (
    <div class="app">
      <TopBar />
      <main class="stage">
        {s === 'match' && m ? (
          <Match start={m} />
        ) : s === 'results' ? (
          <Results />
        ) : s === 'locker' ? (
          <Locker />
        ) : s === 'campaign' ? (
          <Campaign />
        ) : lobby.value ? (
          <Lobby />
        ) : (
          <div class="loading">
            <div>
              <h2>Digging in…</h2>
              <p class="muted">Connecting to the lobby.</p>
            </div>
          </div>
        )}
        <HelpModal />
        {toast.value && (
          <div key={toast.value.id} class={`toast ${toast.value.kind}`} role="status">
            {toast.value.text}
          </div>
        )}
      </main>
    </div>
  );
}
